module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/gotop-7669921c7546038a8af72b6316dbce02.svg&quot;;"